import { Component, ComponentFactoryResolver, ViewChild, ComponentRef } from '@angular/core';

import { CgpComponentBrowserDirective } from './cgp-component-browser.directive';
import { CgpComponentBrowserItem } from './cgp-component-browser-item';

@Component({
    selector: 'cgp-component-browser',
    templateUrl: './cgp-component-browser.template.html'
})
export class CgpComponentBrowserComponent {
    @ViewChild(CgpComponentBrowserDirective, { static: true }) cgpComponentBrowserHost;

    private browserItem;
    private readonly history = [];

    constructor(private readonly componentFactoryResolver: ComponentFactoryResolver) { }

    open(component, data) {
        if (this.browserItem) {
            this.history.push(this.browserItem);
        }

        this.loadComponent(new CgpComponentBrowserItem(component, data));
    }

    back() {
        const history = this.history;

        if (history.length < 1) {
            return;
        }

        this.loadComponent(history.pop());
    }

    historyCount() {
        return this.history.length;
    }

    currentItem() {
        return this.browserItem;
    }

    previousItem() {
        const history = this.history;

        if (history.length < 1) {
            return null;
        }

        return history[history.length - 1];
    }

    item(index) {
        const history = this.history;

        if (history.length < 1 || index >= history.length) {
            return null;
        }

        return history[index];
    }

    clear() {
        this.history.length = 0;
    }

    private loadComponent(item) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(item.component);
        const viewContainerRef = this.cgpComponentBrowserHost.viewContainerRef;

        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = item.data;

        this.browserItem = item;
    }
}
